import { render, staticRenderFns } from "./landDoingInfoAddInfo.vue?vue&type=template&id=70b8c454"
import script from "./landDoingInfoAddInfo.vue?vue&type=script&lang=js"
export * from "./landDoingInfoAddInfo.vue?vue&type=script&lang=js"
import style0 from "./landDoingInfoAddInfo.vue?vue&type=style&index=0&id=70b8c454&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports